import MapMarkerIcon from "@components/Icons/MapMarkerIcon";
import getLockerProviderData from "@components/Lockers/_lib/getLockerProviderData";

const LockerCardCarrierBadge = ({ locker }) => {
  const { name: carrierName, color } = getLockerProviderData(locker);

  return (
    <div
      style={{ backgroundColor: color }}
      className="flex items-center w-fit gap-[2px] rounded-[4px] py-[4px] pl-[4px] pr-[6px] text-[14px] font-medium text-white"
    >
      <MapMarkerIcon color="#fff" width="16px" height="16px" />

      {carrierName && <span>{carrierName}</span>}
    </div>
  );
};

export default LockerCardCarrierBadge;
